import render from "./render";

import App from "./screens";

render(App);
